import React, { useImperativeHandle, forwardRef, useState, useEffect } from "react";
import Switch from "react-switch"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Button,
    Modal,
    Spinner,
    Table,
    Pagination,
    PaginationItem,
    PaginationLink,
    Input
} from "reactstrap";

const SelectableListModal = forwardRef(({ data = [], pageSize = 10, title = "Select Items", onClose }, ref) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedItems, setSelectedItems] = useState([]);
    const [currentPageData, setCurrentPageData] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    // Expose the show method to the parent via ref
    useImperativeHandle(ref, () => ({
        show: () => {
            setModalOpen(true);
            setCurrentPage(1);
        },
        getSelectedItems: () => selectedItems,
        reset: () => {
            setSelectedItems([]);
            setSelectAll(false);
        },
        setSelectedItemsFromParent: (values) => {
            setSelectedItems(values);
        }
    }));

    useEffect(() => {
        const start = (currentPage - 1) * pageSize;
        const end = start + pageSize;
        setCurrentPageData(data.slice(start, end));
    }, [currentPage, data]);

    useEffect(() => {
        if (selectAll) {
            const allValues = data.map(item => item.value);
            setSelectedItems(allValues);
        } else {
            setSelectedItems([]);
        }
    }, [selectAll]);

    const handleSelectItem = (value) => {
        if (selectedItems.includes(value)) {
            setSelectedItems(prev => prev.filter(v => v !== value));
        } else {
            setSelectedItems(prev => [...prev, value]);
        }
    };


    const closeModal = () => {
        setModalOpen(false);
        console.log("Selected Items1:", selectedItems);
        if (onClose) {
            console.log("Selected Items:", selectedItems);
            onClose(selectedItems);
        }
    };
    const totalPages = Math.ceil(data.length / pageSize);

    return (
        <Modal isOpen={modalOpen} toggle={closeModal} size="xl">
            <Card className="mb-0">
                <CardBody>
                    <Row className="mb-2">
                        <Col md={8}>
                            <CardTitle tag="h5">{title}</CardTitle>
                        </Col>
                        <Col md={4} className="text-end">
                            <Button color="danger" size="sm" onClick={closeModal}>
                                Close
                            </Button>
                        </Col>
                    </Row>

                    <Row className="mb-2">
                        <Col>
                            <Input
                                type="checkbox"
                                checked={selectAll}
                                onChange={(e) => setSelectAll(e.target.checked)}
                            />{" "}
                            Select All
                        </Col>
                    </Row>

                    <Table bordered hover size="sm">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Location Code</th>
                                <th>Location Name</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentPageData.map((item, idx) => (
                                <tr key={idx}>
                                    <td>{pageSize * (currentPage - 1) + idx + 1}</td>
                                    <td>{item.value}</td>
                                    <td>{item.label}</td>
                                    <td>
                                        <Switch
                                            onChange={() => handleSelectItem(item.value)}
                                            checked={selectedItems.includes(item.value)}
                                            height={20}
                                            width={40}
                                            handleDiameter={18}
                                            offColor="#bbb"
                                            onColor="#0d6efd"
                                            uncheckedIcon={false}
                                            checkedIcon={true}
                                            id={`${item.value}-switch`}

                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    {totalPages > 1 && (
                        <Pagination className="justify-content-center mt-3" size="sm">
                            {[...Array(totalPages)].map((_, i) => (
                                <PaginationItem key={i} active={i + 1 === currentPage}>
                                    <PaginationLink onClick={() => setCurrentPage(i + 1)}>
                                        {i + 1}
                                    </PaginationLink>
                                </PaginationItem>
                            ))}
                        </Pagination>
                    )}
                </CardBody>
            </Card>
        </Modal>
    );
});

export default SelectableListModal;
